//Live
//export const API_BASE_URL = "https://api-supplier-test.v2a.digital/api/v1";

//Stagging
export const API_BASE_URL = "https://api-supplier.virtualtoactual.cloud/api/v1";

export const API_Image_BaseUrl = "https://api-supplier.virtualtoactual.cloud/";

// Backend host without the /api/v1 prefix — static files (error log JSON etc.) are served from here.
export const API_ORIGIN = new URL(API_BASE_URL).origin;

export const SUPPLIER_BACKEND_API_ENDPOINTS = {
  //Login and JWT token operations
  authentication: {
    login: "/users/login",
    menuAccess: (role_code: number | string) =>
      `/users/menu-access?role_code=${role_code}`,
    verifyToken: "/users/verify-token",
    changePasswordLink: "/users/change-password-link",
    logout: "/users/logout",
  },
  pincode: {
    detail: (pincode: number | string) => `/location/pincode?pin=${pincode}`,
    create: `/location/pincode`,
    // NOTE: list/details/update/delete below are assumed to follow the same REST shape as cities; confirm with backend.
    list: (querystring: string) => `/location/pincode?${querystring}`,
    details: (id: number | string) => `/location/pincode/${id}`,
    update: (id: number | string) => `/location/pincode/${id}`,
    delete: (id: number | string) => `/location/pincode/${id}`,
  },
  //Vendor management operations
  vendors: {
    list: (querystring: string) => `/vendors?${querystring}`,
    details: (id: number | string) => `/vendors/${id}`,
    create: "/vendors",
    update: (id: number | string) => `/vendors/${id}`,
    delete: (id: number | string) => `/vendors/${id}`,
  },
  //User management operations
  users: {
    list: (querystring: string) => `/users?${querystring}`,
    details: (userid: number | string) => `/users/${userid}`,
    create: "/users",
    update: (userid: number | string) => `/users/${userid}`,
    delete: (userid: number | string) => `/users/${userid}`,
    //changePassword: (userid: number | string) => `/users/${userid}/change-password`,
    //updateStatus: (userid: number | string) => `/users/${userid}/status`,
  },
  //Supplier management operations
  suppliers: {
    list: (querystring: string) => `/suppliers?${querystring}`,
    details: (id: number | string) => `/suppliers/${id}`,
    create: "/suppliers",
    update: (id: number | string) => `/suppliers/${id}`,
    delete: (id: number | string) => `/suppliers/${id}`,
  },
  //Supplier wallets. The balance lives in supplier_wallet (one per supplier, created when the supplier registers) and every balance change writes a ledger entry (transaction) with the supplier. A supplier user always reads their own wallet - supplier_id is ignored for them; admins pass supplier_id. Listing, adjustments and suspending are admin-only.
  supplierWallet: {
    list: (querystring: string) => `/supplier-wallet?${querystring}`,
    balance: (supplier_id: number | string) =>
      `/supplier-wallet/balance?supplier_id=${supplier_id}`,
    transactions: (querystring: string) =>
      `/supplier-wallet/transactions?${querystring}`,
    adjust: `/supplier-wallet/adjust`,
    update: (supplierid: number | string) =>
      `/supplier-wallet/${supplierid}/status`,
  },
  flights: {
    list: (querystring: string) => `/flights?${querystring}`,
    details: (flightid: number | string) => `/flights/${flightid}`,
    create: "/flights",
    update: (flightid: number | string) => `/flights/${flightid}`,
    delete: (flightid: number | string) => `/flights/${flightid}`,
  },
  countries: {
    list: (querystring: string) => `/location/countries?${querystring}`,
    details: (id: number | string) => `/location/countries/${id}`,
    detailByCode: (code: string) => `/location/countries/code/${code}`,
    create: "/location/countries",
    update: (id: number | string) => `/location/countries/${id}`,
    delete: (id: number | string) => `/location/countries/${id}`,
  },
  states: {
    list: (querystring: string) => `/location/states?${querystring}`,
    details: (id: number | string) => `/location/states/${id}`,
    create: "/location/states",
    update: (id: number | string) => `/location/states/${id}`,
    delete: (id: number | string) => `/location/states/${id}`,
  },
  cities: {
    list: (querystring: string) => `/location/cities?${querystring}`,
    details: (id: number | string) => `/location/cities/${id}`,
    create: "/location/cities",
    update: (id: number | string) => `/location/cities/${id}`,
    delete: (id: number | string) => `/location/cities/${id}`,
  },
  airlines: {
    list: (querystring: string) => `/airlines?${querystring}`,
    details: (id: number | string) => `/airlines/${id}`,
    create: "/airlines",
    update: (id: number | string) => `/airlines/${id}`,
    delete: (id: number | string) => `/airlines/${id}`,
  },
  airports: {
    list: (querystring: string) => `/airports?${querystring}`,
    details: (id: number | string) => `/airports/${id}`,
    detailsByCode: (code: string) => `/airports/code/${code}`,
    create: "/airports",
    update: (id: number | string) => `/airports/${id}`,
    delete: (id: number | string) => `/airports/${id}`,
  },
  rbacRoles: {
    list: (querystring: string) => `/rbac/roles?${querystring}`,
    details: (code: number | string) => `/rbac/roles/${code}`,
    create: "/rbac/roles",
    update: (code: number | string) => `/rbac/roles/${code}`,
    delete: (code: number | string) => `/rbac/roles/${code}`,
  },
  rbacModules: {
    list: (querystring: string) => `/rbac/modules?${querystring}`,
    details: (id: number | string) => `/rbac/modules/${id}`,
    create: "/rbac/modules",
    update: (id: number | string) => `/rbac/modules/${id}`,
    delete: (id: number | string) => `/rbac/modules/${id}`,
  },
  rbacRoleModulesAccess: {
    list: (querystring: string) => `/rbac/role-module-access?${querystring}`,
    details: (rolecode: number | string) =>
      `/rbac/role-module-access/${rolecode}`,
    create: "/rbac/role-module-access",
    update: (id: number | string) => `/rbac/role-module-access/${id}`,
    delete: (id: number | string) => `/rbac/role-module-access/${id}`,
    listByRoleCode: (role_code: number | string) =>
      `/rbac/role-module-access-with-modules/${role_code}`,
    detailByModuleId: (moduleid: number | string) =>
      `/rbac/role-module-access/${moduleid}`,
  },
  rbacMenus: {
    list: (querystring: string) => `/rbac/menus?${querystring}`,
    details: (id: number | string) => `/rbac/menus/${id}`,
    create: "/rbac/menus",
    update: (id: number | string) => `/rbac/menus/${id}`,
    delete: (id: number | string) => `/rbac/menus/${id}`,
  },
  agents: {
    list: (querystring: string) => `/agents?${querystring}`,
    details: (id: number | string) => `/agents/${id}`,
    create: "/agents",
    update: (id: number | string) => `/agents/${id}`,
    delete: (id: number | string) => `/agents/${id}`,
  },
  inventory: {
    list: (querystring: string) => `/inventory?${querystring}`,
    create: "/inventory",
  },
};
